import { render } from "./oficialiaUsuario.vue?vue&type=template&id=054f217a&scoped=true"
import script from "./oficialiaUsuario.vue?vue&type=script&lang=js"
export * from "./oficialiaUsuario.vue?vue&type=script&lang=js"

import "./oficialiaUsuario.vue?vue&type=style&index=0&id=054f217a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054f217a"]])

export default __exports__